<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        隐私政策
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="隐私政策：" prop="detail">
           <editor :value="editorContent" :height="350" v-model="editorContent"></editor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { privacyPolicy, privacyPolicyInfo } from '@/api/base'
import Editor from '@/components/Editor.vue'
export default {
  name: 'Service_agreement',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      ruleForm: {
        detail: ''
      },
      rules: {
        detail: [
          { required: true, message: '请输入视频详情', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    var that = this;
    privacyPolicyInfo({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.editorContent = data;
        }
    })
  },
  methods: {
    // 保存操作
    saveBtn () {
      let that = this
      let editorContent = that.editorContent
      if (editorContent === '') {
        this.$message.error('请输入隐私政策')
        return false
      }
      let passData = {
        detail: editorContent
      }
      that.fullscreenLoading = true
      privacyPolicy(passData).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.$router.go(0)
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/base/Privacy_policy.vue